// extracted by mini-css-extract-plugin
export default {"nowrap":"nowrap_b43b0"};